<template>
  <div class="oneplus-app" v-if="visible">
    <span @click="onCallApp">{{ $t(translateName) }}</span>
    <svg-icon name="icon-close" @click="onClose"></svg-icon>
  </div>
  <WapDialog
    v-model:show="storeDownloadVisible"
    :confirmCallBack="toStoreDownloadApp"
  >
    <p class="oneplus-app-store">{{ isAppMarket ? $t('common.openAppMarketInfo') : $t('openStore') }}</p>
  </WapDialog>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useSystemStore } from '@/stores/system'



const route = useRoute()
const systemStore = useSystemStore()
const { proxy } = getCurrentInstance()
const { isAppMarket } = storeToRefs(systemStore) 

const visible = ref(!localStorage.getItem('hiddenAppDialog') && (import.meta.env.VITE_BRAND === 'ONEPLUS' || (import.meta.env.VITE_BRAND === 'OPPO' && import.meta.env.VITE_COUNTRY === 'GLOBAL')))

const translateName = ref(`openApp${import.meta.env.VITE_BRAND}`)

const storeDownloadVisible = ref(false)

const openAppGaParams = computed(() => route.params.id ? {
    "thread_id": route.params.id
  } : {})

const onCallApp = () => {
  
  proxy.$ga('open_with_app', {
    "action": 'click popsup',
    ...openAppGaParams.value
  })
  
  let appBaseUrl = ''
  switch (import.meta.env.VITE_COUNTRY) {
    case 'PARIS': 
      appBaseUrl = 'opluscommunity://community.oneplus.com'
      break
    case 'CHINA':
      appBaseUrl = 'opluscommunity://bbs.oneplus.com'
      break
    case 'GLOBAL':
      appBaseUrl = 'opluscommunity://community.oppo.com'
      break
  }
  if (import.meta.env.VITE_BRAND === 'ONEPLUS') {
    appBaseUrl = import.meta.env.VITE_COUNTRY === 'PARIS' ? 'opluscommunity://community.oneplus.com' : 'opluscommunity://bbs.oneplus.com'
  }

  let href = `${appBaseUrl}/app/main`
  if (route.params.id && route.name === 'thread') {
    href = `${appBaseUrl}/app/thread?threadId=${route.params.id}`
  }
  
  let hasLeavePage = false
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      hasLeavePage = true
    }
  });
  setTimeout(() => {
    if(!hasLeavePage){
      storeDownloadVisible.value = true
      document.removeEventListener('visibilitychange')
    }
  }, 3000);

  location.href = href

}

const toStoreDownloadApp = () => {
  let path = ''
  switch (import.meta.env.VITE_COUNTRY) {
    case 'PARIS': 
      path = 'https://play.google.com/store/apps/details?id=net.oneplus.forums'
      break
    case 'CHINA':
      path = 'market://details?id=com.oneplus.bbs'
      break
    case 'GLOBAL':
      path = 'https://play.google.com/store/apps/details?id=com.oppo.community.global'
      break
  }
  if (isAppMarket.value) {
    let appId = ''
    switch(import.meta.env.VITE_COUNTRY) {
      case 'PARIS':
        appId = '4070231'
        break
      case 'GLOBAL':
        appId = '31769351'
        break
      default:
    }
    proxy.$openAppInfo(appId)
  } else {
    window.open(path)
  }
  
  storeDownloadVisible.value = false
}

const onClose = () => {
  visible.value = false
  localStorage.setItem('hiddenAppDialog', true)
  document.getElementsByClassName('post-bar')[0].style.bottom = '40px'
}

onMounted(() => {
  try {
    let io = new IntersectionObserver((a,b) => {
      if (a[0].intersectionRatio > 0) {
        // 打开app弹窗曝光埋点
        proxy.$ga('open_with_app', {
          "action": 'popsup impression',
          ...openAppGaParams.value
        })
        io.unobserve(document.querySelector(`.oneplus-app`));
      }
    });
    io.observe(document.querySelector(`.oneplus-app`))
  } catch (error) {}
})

</script>

<style lang="postcss" scoped>
.oneplus-app {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: fit-content;
  height: 36px;
  background: var(--theme);
  border-radius: var(--button-radius);
  z-index: 999;
  &-store {
    width: 100%;
    text-align: center;
    padding: 20px 0;
  }
  span {
    position: relative;
    padding: 0 10px 0 13px;
    color: rgba(255, 255, 255, .85);
    white-space: nowrap;
    height: 20px;
    box-sizing: border-box;
    &::after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.33px;
      height: 19px;
      background: rgba(255, 255, 255, .85);
    }
  }
  .svg-icon {
    width: 16px;
    height: 16px;
    margin: 0 12px 0 10px;
    color: rgba(255, 255, 255, .85);
  }
}
</style>